import { StateCreator } from 'zustand'

import { CombinedZustandSlices, EditQuoteSlice, Quote } from '../types'

export const createEditQuoteSlice: StateCreator<CombinedZustandSlices, [], [], EditQuoteSlice> = (
  set,
  get,
) => ({
  editQuotes: {},
  getEditQuoteData: (quoteId, quoteSection) => {
    const quoteData = get().editQuotes[quoteId]

    if (!quoteData || (quoteSection && !quoteData[quoteSection])) {
      return null
    }

    if (quoteSection) {
      return quoteData[quoteSection]
    }

    return quoteData
  },
  getEditQuoteStepData: (quoteId, stepName) => {
    const quoteData = get().editQuotes[quoteId]
    if (!quoteData || (stepName && !quoteData.pageState[stepName])) {
      return null
    }
    if (!stepName) {
      return quoteData.pageState
    }
    return quoteData.pageState[stepName]
  },
  createEditQuote: (quoteId, data) =>
    set(({ editQuotes }) => ({
      editQuotes: { ...editQuotes, [quoteId]: data as Quote },
    })),
  completeEditQuoteStep: (quoteId, step, data) =>
    set(({ editQuotes }) => {
      const currentFormProgress = editQuotes[quoteId]?.formProgress ?? []

      return {
        editQuotes: {
          ...editQuotes,
          [quoteId]: {
            ...editQuotes[quoteId],
            formProgress: currentFormProgress.includes(step)
              ? currentFormProgress
              : [...currentFormProgress, step],

            pageState: { ...editQuotes[quoteId].pageState, [step]: data },
          },
        },
      }
    }),
  updateEditQuoteStepData: (quoteId, step, data) =>
    set(({ editQuotes }) => ({
      editQuotes: {
        ...editQuotes,
        [quoteId]: {
          ...editQuotes[quoteId],
          pageState: { ...editQuotes[quoteId].pageState, [step]: data },
        },
      },
    })),

  // TODO: Do we need this for edit quote?? just adding this for visibility
  updateEditQuoteStep: (quoteId, step) =>
    set(({ editQuotes }) => {
      const currentFormProgress = editQuotes[quoteId]?.formProgress ?? []

      return {
        editQuotes: {
          ...editQuotes,
          [quoteId]: {
            ...editQuotes[quoteId],
            formProgress: currentFormProgress.includes(step)
              ? currentFormProgress
              : [...currentFormProgress, step],
          },
        },
      }
    }),
  deleteEditQuote: (quoteId) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { [quoteId]: _, ...editQuotes } = get().editQuotes
    set({ editQuotes })
  },
  updateEditQuoteGeneralInfo: (quoteId, data) =>
    set(({ editQuotes }) => ({
      editQuotes: {
        ...editQuotes,
        [quoteId]: {
          ...editQuotes[quoteId],
          generalInfo: { ...editQuotes[quoteId].generalInfo, ...data },
        },
      },
    })),
})
